import React from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import AddPaypalAccountModal from "../../Modals/AddPaypalAccountModal.js";
import DeleteBankModal from "../../Modals/DeleteBankModal.js";

const PayPalListSettings = ({
  paypalAccounts,
  setPaypalAccounts,
  banksAccount,
  setBanksAccount,
}) => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();

  const openAddPaypalModal = () => {
    setModal(() => (
      <AddPaypalAccountModal
        paypalAccounts={paypalAccounts}
        setPaypalAccounts={setPaypalAccounts}
      />
    ));
  };

  const openEditPaypalModal = (email, accountName, index) => {
    const editDetails = {
      AccountOwnerName: accountName,
      AccountEmail: email,
    };
    setModal(() => (
      <AddPaypalAccountModal
        editDetails={editDetails}
        isEdit={true}
        index={index}
        paypalAccounts={paypalAccounts}
        setPaypalAccounts={setPaypalAccounts}
      />
    ));
  };

  const openDeleteBankModal = ({ type, index }) => {
    setModal(() => (
      <DeleteBankModal
        type={type}
        banksAccount={banksAccount}
        index={index}
        setBanksAccount={setBanksAccount}
        paypalAccounts={paypalAccounts}
        setPaypalAccounts={setPaypalAccounts}
      />
    ));
  };

  return (
    <>
      {paypalAccounts && paypalAccounts.length > 0 ? (
        <div className="banks-list">
          <div className="banks-title">
            <h3>{getTextByKey("paypal-accounts")}</h3>
            <div className="add-bank" onClick={() => openAddPaypalModal()}>
              <Icon name="plus" /> {getTextByKey("add-paypal-account")}
            </div>
          </div>
          {paypalAccounts.map((item, index) => (
            <div className="bank-item" key={index}>
              <div className="image">
                <Icon name="paypal-brands" />
              </div>
              <div className="account-owner detail">
                <div className="title-detail">
                  <span>{getTextByKey("account-owner")}</span>
                </div>
                <div className="info-detail">
                  <span>{item.AccountOwnerName}</span>
                </div>
              </div>
              <div className="account-email detail">
                <div className="title-detail">
                  <span>{getTextByKey("account-email")}</span>
                </div>
                <div className="info-detail">
                  <span> {item.AccountEmail}</span>
                </div>
              </div>
              <div className="actions paypal-actions">
                <div
                  className="del-bank"
                  onClick={() =>
                    openDeleteBankModal({
                      type: "paypal",
                      index: item.keyIndex,
                    })
                  }
                >
                  <Icon name="trash-solid-b" />
                </div>
                <div
                  className="edit-bank"
                  onClick={() =>
                    openEditPaypalModal(
                      item.AccountEmail,
                      item.AccountOwnerName,
                      item.keyIndex
                    )
                  }
                >
                  <Icon name="pencil-alt-solid" />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bank-button" onClick={() => openAddPaypalModal()}>
          <Icon name="paypal-brands" />
          <span className="bank-text">
            {" "}
            <Icon name="plus" /> {getTextByKey("add-paypal-account")}
          </span>
        </div>
      )}
    </>
  );
};

export default PayPalListSettings;
